/**
 * Busca Appointments do par profissional+paciente e detecta evolução aberta.
 */
import { GetAppointment } from "@/services/fhir";
import { isEvolutionAppointment } from "./isEvolutionAppointment";
import { toPatientResourceId } from "./evolutionPatient";

const OPEN_STATUSES = ["booked", "arrived"] as const;
const HISTORY_STATUSES = [
  "booked",
  "arrived",
  "fulfilled",
  "pending",
] as const;

export function appointmentsFromBundle(
  bundle?: fhir5.Bundle,
): fhir5.Appointment[] {
  return (bundle?.entry || [])
    .map((e) => e.resource)
    .filter((r): r is fhir5.Appointment => r?.resourceType === "Appointment");
}

export async function fetchPairAppointments(params: {
  patientId: string;
  professionalRef: string;
}): Promise<fhir5.Bundle | undefined> {
  const patientResourceId = toPatientResourceId(params.patientId);
  if (!patientResourceId) return undefined;

  try {
    return await GetAppointment({
      patient: patientResourceId,
      professionalActor: params.professionalRef,
      status: [...HISTORY_STATUSES],
      sort: "-date",
      count: 30,
      includeSlot: true,
      includeSchedule: true,
      includeLocation: true,
      includePatient: true,
    });
  } catch (error) {
    console.error("fetchPairAppointments", error);
    return undefined;
  }
}

export function findOpenEvolution(
  bundle?: fhir5.Bundle,
): fhir5.Appointment | undefined {
  return appointmentsFromBundle(bundle).find(
    (apt) =>
      isEvolutionAppointment(apt) &&
      OPEN_STATUSES.includes(apt.status as (typeof OPEN_STATUSES)[number]),
  );
}
